import React, { useState, useMemo } from "react";

// Assets
import IconXSrc from "assets/x-black.svg";

// Components
import SelectInfiniteCustom from "components/molecules/shared/select-infinite-custom";
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// API
import { useGetListMarketing } from "api/common/query";

// Context
import { useDetailListingCtx } from "pages/dashboard/list-listing/Context";

const PJPOptions = [
  { value: null, label: "Semua" },
  { value: true, label: "PJP" },
  { value: false, label: "Non-PJP" },
];

const ModalDetailFeed = ({ onClose, ...props }) => {
  const { params, setParams } = useDetailListingCtx();
  const [selectedMarketing, setSelectedMarketing] = useState(
    params.agent || { value: "", label: "Semua" },
  );
  const [selectedPJP, setSelectedPJP] = useState(
    PJPOptions.find((option) => option.value === params.is_pjp) ||
      PJPOptions[0],
  );

  const {
    data: marketingData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useGetListMarketing({
    params: {
      _limit: 20,
    },
  });

  const marketingOptions = useMemo(() => {
    if (!marketingData?.pages) return [];

    return marketingData.pages.flatMap((page) =>
      (page?.data?.data || []).map((user) => ({
        value: user.id,
        label: user.full_name,
        id: user.id,
      })),
    );
  }, [marketingData]);

  const handleLoadMoreMarketing = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const handleMarketingChange = (option) => {
    setSelectedMarketing(option);
  };

  const handlePJPChange = (option) => {
    setSelectedPJP(option);
  };

  const handleApplyFilter = () => {
    setParams({
      ...params,
      agent: selectedMarketing,
      page: 1,
      is_pjp: selectedPJP.value,
    });
    onClose();
  };

  const handleResetFilter = () => {
    setSelectedMarketing(null);
    setSelectedPJP(null);
    setParams({
      ...params,
      agent: null,
      page: 1,
      is_pjp: null,
    });
    onClose();
  };

  const isHasFilter = useMemo(() => {
    return params.agent || params.is_pjp;
  }, [params]);

  return (
    <Modal isOpen={true} onClose={onClose} {...props}>
      <div
        className="w-[314px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="py-2 px-4 flex items-center justify-between border-b border-solid border-[#D8D8D9]">
          <span className="text-[17px] font-inter-semibold text-[#252526]">
            Filter
          </span>
          <img
            src={IconXSrc}
            alt="Close"
            onClick={onClose}
            className="cursor-pointer w-[14px] h-[14px] object-contain"
          />
        </div>

        <div className="px-4 py-2">
          <div className="mb-4">
            <label className="block text-[13px] font-inter-medium text-[#252526] mb-2">
              Marketing
            </label>
            <SelectInfiniteCustom
              options={[{ value: "", label: "Semua" }, ...marketingOptions]}
              value={selectedMarketing}
              onChange={handleMarketingChange}
              onLoadMore={handleLoadMoreMarketing}
              hasMore={hasNextPage}
              isLoading={isFetchingNextPage}
              placeholder="Pilih Marketing..."
            />
          </div>

          <div className="mb-4">
            <label className="block text-[13px] font-inter-medium text-[#252526] mb-2">
              PJP atau non-PJP
            </label>
            <SelectInfiniteCustom
              options={PJPOptions}
              value={selectedPJP}
              onChange={handlePJPChange}
              placeholder="PJP"
            />
          </div>

          <div className="flex gap-2 mt-6 justify-end">
            <Button
              disabled={!isHasFilter}
              onClick={handleResetFilter}
              text="Reset"
              type="negative"
            />
            <Button onClick={handleApplyFilter} text="Terapkan" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default function Wrapper({ isOpen, ...props }) {
  if (!isOpen) return null;
  return <ModalDetailFeed isOpen={isOpen} {...props} />;
}
